// src/common/api/siteTopBannerPublicApi.js
import { sendRequest } from "../sendRequest";

const BASE = "/api/public/site-top-banners";

const siteTopBannerPublicApi = {
  /**
   * 현재 노출할 활성 배너 1건
   * response: SiteTopBannerDTO | null
   */
  async fetchActive() {
    const res = await sendRequest(`${BASE}/active`, { method: "GET" });
    if (res && typeof res === "object" && res.success === false) {
      return null;
    }
    return res || null;
  },
};

export default siteTopBannerPublicApi;
